/**
 * 用一个范围生成数组
 * @param start
 * @param end
 * @param step
 * @example
 * range(3) // => [0, 1, 2]
 * range(-3) // => [1,2]
 * range(1, 3) // => [1,2]
 * range(1, 5, 2) // => [1,3,]
 * range(1, 6, 2) // => [1,3,5]
 */
export function range(start, end, step) {
    if (end === void 0) { end = NaN; }
    if (step === void 0) { step = start <= end ? 1 : -1; }
    if (isNaN(end)) {
        end = start;
        start = 0;
        step = start <= end ? 1 : -1;
    }
    var result = [];
    if (start <= end) {
        if (step < 0) {
            throw new TypeError("step cannot less then 0: ".concat(step));
        }
        for (var i = start; i < end; i += step) {
            result.push(i);
        }
    }
    else {
        if (step > 0) {
            throw new TypeError("step cannot greeter then 0: ".concat(step));
        }
        for (var i = start; i > end; i += step) {
            result.push(i);
        }
    }
    return result;
}
//# sourceMappingURL=range.js.map